module.exports = "/images/chart.51491402484fc3a821feaff8c703ef89.svg";